import { useEffect } from 'react'

function useKeyPress (key, callback) {
  useEffect(() => {
    const handler = function (event) {
      if (event.key === key) {
        callback()
      }
    }
    window.addEventListener('keydown', handler)
    return () => {
      window.removeEventListener('keydown', handler)
    }
  }, [])
}

export default useKeyPress



// WEBPACK FOOTER //
// ./src/useKeyPress.js